// extracted by css-extract-rspack-plugin
export default {"unorderedList":"content-editor-plugin-unordered-list-UnorderedList-unorderedList-09fa7865"};